export class GzzChild {

  FirstName: string;
  LastName: string;
  IDNumber: string;
  DateOfBirth: Date;

  constructor(data: GzzChild) {

    Object.assign(this, data);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/general/GzzChild.ts